/* Flavour picker for starter kits and bundles (snippets/kit.product-variant-picker.dropdown.liquid).
   Wraps the theme's own <select>, which stays the source of truth for the variant picker:
   on the page one tidy line ("Black Mamba · Black Colossus  Change"), and "Change" opens a list
   (from the bottom on phones, a centred panel on computers), grouped by brand, with each flavour's photo. A search box only appears for
   very long lists (over 30), which kits do not have.
   Only what is in the <select> is listed, and the theme leaves sold-out flavours out of it.
   If this script does not load, the plain dropdown shows instead. */
(function () {
  if (customElements.get('sg-flavour-pick')) return;

  var BRANDS = ['Overdozz', 'Savacco', 'Starbuzz', 'Al Fakher', 'Adalya', 'Darkside', 'Musthave', 'Element', 'Tangiers', 'Fumari'];

  function isUpper(s) { return s === s.toUpperCase() && /[A-Z]/.test(s); }
  function titleCase(s) {
    if (!isUpper(s)) return s;
    return s.toLowerCase().replace(/(^|[\s\-\/])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); })
      .replace(/\bK\.o\.?/i, 'K.O.').replace(/\b(\d+)(St|Nd|Rd|Th)\b/g, function (m, n, x) { return n + x.toLowerCase(); });
  }
  function sentenceCase(s) {
    if (!isUpper(s)) return s;
    s = s.toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  // "Overdozz 1ST LOVE (WATERMELON CHEWING GUM)" -> { brand: "Overdozz", name: "1st Love", note: "Watermelon chewing gum" }
  // Kit flavours written without a brand at the start are Savacco (the kits hold Savacco or Overdozz);
  // <sg-flavour-pick data-default-brand="..."> changes this if ever needed.
  var DEFAULT_BRAND = 'Savacco';
  var NO_FLAVOUR = /^no flavour$/i;
  function parse(v, fallback) {
    var brand = '', rest = v.trim();
    for (var i = 0; i < BRANDS.length; i++) {
      var b = BRANDS[i];
      if (rest.toLowerCase().indexOf(b.toLowerCase() + ' ') === 0) { brand = b; rest = rest.slice(b.length + 1).trim(); break; }
    }
    var note = '', m = /^(.*?)\s*\(([^)]*)\)\s*$/.exec(rest);
    if (m) { rest = m[1]; note = m[2]; }
    return { brand: brand || fallback || '', name: titleCase(rest), note: sentenceCase(note) };
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

  // Photo for each flavour: found through the shop's own search (every kit flavour is also sold on its own,
  // e.g. "Savacco Black Mamba (Black Colossus)"), so nothing to set up. Remembered for the visit.
  var thumbCache = {};
  try { thumbCache = JSON.parse(sessionStorage.getItem('sgfp-thumbs') || '{}'); } catch (e) {}
  function words(s) { return ' ' + String(s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' '; }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function findThumb(p) {
    var key = p.brand + '|' + p.name;
    if (key in thumbCache) return Promise.resolve(thumbCache[key]);
    var q = (p.brand + ' ' + p.name).trim();
    var url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[options][fields]=title';
    return fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var list = (d && d.resources && d.resources.results && d.resources.results.products) || [], hit = '';
      var wb = words(p.brand), wn = words(p.name);
      for (var i = 0; i < list.length; i++) {
        var t = words(list[i].title);
        if (/ (kit|pack|bundle) /.test(t)) continue;
        if ((!p.brand || t.indexOf(wb) > -1) && t.indexOf(wn) > -1) { hit = list[i].image || (list[i].featured_image && list[i].featured_image.url) || ''; break; }
      }
      thumbCache[key] = hit;
      try { sessionStorage.setItem('sgfp-thumbs', JSON.stringify(thumbCache)); } catch (e) {}
      return hit;
    }).catch(function () { return ''; });
  }
  function thumbInto(box, p, w) {
    findThumb(p).then(function (src) {
      if (!src) { box.classList.add('sg-fp__thumb--none'); return; }
      var img = new Image(); img.alt = ''; img.decoding = 'async'; img.src = sized(src, w);
      img.onload = function () { box.appendChild(img); box.classList.add('sg-fp__thumb--on'); };
    });
  }

  class SgFlavourPick extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      if (!this.select || this.row) return;
      this.label = this.dataset.label || 'flavour';
      this.defaultBrand = this.dataset.defaultBrand || DEFAULT_BRAND;
      this.row = el('button', 'sg-fp__row');
      this.row.type = 'button';
      this.row.setAttribute('aria-haspopup', 'dialog');
      this.row.addEventListener('click', () => this.open());
      this.insertBefore(this.row, this.firstChild);
      this.paintRow();
      this.classList.add('sg-fp--ready');
    }
    options() {
      return [...this.select.options].filter(function (o) { return o.value && !o.disabled && !NO_FLAVOUR.test(o.value); });
    }
    paintRow() {
      var o = this.select.options[this.select.selectedIndex];
      // "No flavour" is the Shisha Only choice (e.g. Carbine: Shisha Only / Starter Kit): hide the whole flavour row
      var box = this.closest('fieldset, .kit-fieldset') || this;
      var none = !!(o && NO_FLAVOUR.test(o.value));
      // "No flavour" kept from Shisha Only after switching to Starter Kit (that combination doesn't exist, so the theme
      // lists it under Sold out): move to the first flavour in stock instead
      if (none && o.parentElement && o.parentElement.tagName === 'OPTGROUP') {
        var first = this.options()[0];
        if (first) { this.select.value = first.value; this.select.dispatchEvent(new Event('change', { bubbles: true })); return; }
        none = false;   // no flavour in stock at all: show the row so it's clear why the kit is unavailable
      }
      box.hidden = none; box.style.display = none ? 'none' : '';
      if (none) return;
      this.row.textContent = '';
      var text = el('span', 'sg-fp__text');
      if (o && o.value) {
        var p = parse(o.value, this.defaultBrand);
        var rt = el('span', 'sg-fp__thumb'); this.row.appendChild(rt); thumbInto(rt, p, 120);
        text.appendChild(el('span', 'sg-fp__name', p.name));
        var sub = [p.brand, p.note].filter(Boolean).join(' · ');
        if (sub) text.appendChild(el('span', 'sg-fp__sub', sub));
      } else {
        text.appendChild(el('span', 'sg-fp__name', 'Choose your ' + this.label));
      }
      this.row.appendChild(text);
      this.row.appendChild(el('span', 'sg-fp__change', o && o.value ? 'Change' : 'Choose'));
    }
    open() {
      var self = this, opts = this.options();
      var dlg = el('dialog', 'sg-fp__sheet');
      dlg.setAttribute('aria-label', 'Choose your ' + this.label);
      var head = el('div', 'sg-fp__head');
      head.appendChild(el('span', 'sg-fp__title', 'Choose your ' + this.label));
      var x = el('button', 'sg-fp__close', '✕'); x.type = 'button'; x.setAttribute('aria-label', 'Close');
      head.appendChild(x);
      dlg.appendChild(head);
      var search = null;
      if (opts.length > 30) {
        search = el('input', 'sg-fp__search'); search.type = 'search'; search.placeholder = 'Search ' + this.label + 's…';
        search.setAttribute('aria-label', 'Search ' + this.label + 's');
        dlg.appendChild(search);
      }
      var list = el('div', 'sg-fp__list'); list.setAttribute('role', 'radiogroup');
      dlg.appendChild(list);
      var empty = el('p', 'sg-fp__empty', 'No match. Clear the search to see them all.'); empty.hidden = true;
      dlg.appendChild(empty);

      // group by brand, keeping the shop's order
      var groups = [], byBrand = {};
      opts.forEach(function (o) {
        var p = parse(o.value, self.defaultBrand);
        if (!byBrand[p.brand]) { byBrand[p.brand] = []; groups.push(p.brand); }
        byBrand[p.brand].push({ o: o, p: p });
      });
      var showHeads = groups.length > 1;
      var current = this.select.value, items = [];
      groups.forEach(function (g) {
        var head = null;
        if (showHeads && g) { head = el('div', 'sg-fp__group', g); list.appendChild(head); }
        byBrand[g].forEach(function (it) {
          var b = el('button', 'sg-fp__opt'); b.type = 'button';
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', it.o.value === current ? 'true' : 'false');
          b.appendChild(el('span', 'sg-fp__dot'));
          var th = el('span', 'sg-fp__thumb'); b.appendChild(th); thumbInto(th, it.p, 120);
          var t = el('span', 'sg-fp__text');
          t.appendChild(el('span', 'sg-fp__name', it.p.name));
          if (it.p.note) t.appendChild(el('span', 'sg-fp__sub', it.p.note));
          b.appendChild(t);
          b.addEventListener('click', function () { self.choose(it.o.value, dlg); });
          list.appendChild(b);
          items.push({ b: b, head: head, text: (it.p.brand + ' ' + it.p.name + ' ' + it.p.note).toLowerCase() });
        });
      });
      if (search) search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase(), shown = 0, heads = new Map();
        items.forEach(function (i) {
          var on = !q || i.text.indexOf(q) > -1;
          i.b.hidden = !on; if (on) shown++;
          if (i.head) heads.set(i.head, (heads.get(i.head) || false) || on);
        });
        heads.forEach(function (on, h) { h.hidden = !on; });
        empty.hidden = shown > 0;
      });

      function close() { dlg.close(); }
      x.addEventListener('click', close);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });   // tap outside the panel
      dlg.addEventListener('close', function () { dlg.remove(); document.documentElement.classList.remove('sg-fp-open'); self.row.focus({ preventScroll: true }); });
      document.body.appendChild(dlg);
      document.documentElement.classList.add('sg-fp-open');
      dlg.showModal();
      var sel = list.querySelector('[aria-checked="true"]');
      if (sel) { sel.scrollIntoView({ block: 'center' }); }
      // focus the panel itself, so no outline is drawn round an option when it opens (keyboard users can tab on)
      dlg.tabIndex = -1; dlg.focus({ preventScroll: true });
    }
    choose(value, dlg) {
      dlg.close();
      if (value === this.select.value) return;
      this.select.value = value;
      this.paintRow();
      // the theme's variant picker listens for this and loads the chosen kit
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  customElements.define('sg-flavour-pick', SgFlavourPick);
})();
